export const colors = {
  BC1: 'rgba(249, 249, 249, 0.92)',
  BC2: '#f6f6f6',
  BC3: '#fbfbfb',
  BC5: 'rgba(0, 0, 0, 0.59)',
  BC6: '#f0f0f0',
  BC7: '#141414',
  BC9: '#f0f0f0',
  BC10: '#d3d3d3',
  BC11: '#e8e8e8',
  BC12: '#aaa',
  BC13: '#8ab67c',

  C1: '#272463',
  C1a: '#312c90',
  C2: '#fff',
  C3: '#505050',
  C3a: '#757575',
  C4: '#000',
  C4a: '#485e77',
  C5: '#444',
  C6: '#222',
  C7: '#ececec',
  C8: '#262a61',
  C10: '#6b6b6b',
  C11: '#b94a48',

  BD1: '#c2c2c2',
  BD2: '#d1d1d1'
};



// WEBPACK FOOTER //
// ./styles/core/light.color.style.js